import { FunctionComponent, memo, useEffect, useState } from "react";
import { Title } from "components/text";
import { NavigationLink } from "components/navigation";
import { ErrorIndicator } from "components/errors";
import { useProject } from "hooks/useProject";
import styles from "./ProjectHeader.module.css";

interface ProjectHeaderProps {
  projectId: string;
}

/** Shared heading for every page nested under /:projectId — shows the current
 * project's name and the Post Submit Target error indicator. */
const ProjectHeaderBase: FunctionComponent<ProjectHeaderProps> = ({ projectId }) => {
  const projectCache = useProject();

  const [projectName, setProjectName] = useState<string>(projectCache.getProjectById(projectId)?.name ?? projectId);

  useEffect(() => {
    setProjectName(projectCache.getProjectById(projectId)?.name ?? projectId);
  }, [projectCache, projectId]);

  return (
    <div className={styles.header}>
      <NavigationLink to={`/${projectId}`}>
        <Title level={1} size="medium">
          {projectName ?? projectId}
        </Title>
      </NavigationLink>
      <ErrorIndicator projectId={projectId} />
    </div>
  );
};

export const ProjectHeader = memo(ProjectHeaderBase)
